import React from 'react';

import Box from '@mui/material/Box';

export const ColorBadge = ({ color }: { color: string }) => (
    <Box
        display="inline-block"
        height={8}
        width={8}
        borderRadius={4}
        marginRight={1}
        sx={{ backgroundColor: color }}
    ></Box>
);
